import React from "react";
import { Link } from "react-router-dom/dist";
import phoneIcon from "../assets/img/icons/phone.png";
import mailIcon from "../assets/img/icons/mail.png";
import locationIcon from "../assets/img/icons/loc.png";
import scrollTop from "../assets/img/icons/scroll-top.png";
import footerLogo from "../assets/img/general/footer-logo.png";

const Footer = () => {
  return (
    // <footer className="footer -type-1 bg-grey text-white">
    //   <div className="container">
    //     <div className="pt-60 pb-60">
    //       <div className="row y-gap-40 justify-between xl:justify-start">
    //         <div className="col-xl-3 col-lg-4 col-sm-6">
    //           <h5 className="text-18 fw-500 mb-30">Contact Us</h5>

    //           <div className="d-flex y-gap-5 flex-column">
    //             <a
    //               href="tel:9833111510"
    //               className="text-15 fw-500 text-white mt-5"
    //             >
    //               +91 983 311 1510
    //             </a>
    //             <a
    //               href="tel:9594001042"
    //               className="text-15 fw-500 text-white mt-5"
    //             >
    //               +91 959 400 1042
    //             </a>
    //             <a
    //               href="mailto:fitizenindia@gmail.com"
    //               className="text-15 fw-500 text-white mt-5"
    //             >
    //               fitizenindia@gmail.com
    //             </a>
    //           </div>
    //           <div className="d-flex x-gap-10 items-center mt-40">
    //             <a href="#" className="social-icon">
    //               <i className="icon-facebook text-30"></i>
    //             </a>
    //             <a href="#" className="social-icon">
    //               <i className="icon-twitter text-30"></i>
    //             </a>
    //             <a href="#" className="social-icon">
    //               <i className="icon-instagram text-30"></i>
    //             </a>
    //             <a href="#" className="social-icon">
    //               <i className="icon-linkedin text-30"></i>
    //             </a>
    //           </div>
    //         </div>

    //         <div className="col-xl-3 col-lg-4 col-sm-6">
    //           <h5 className="text-18 fw-500 mb-30">Address</h5>
    //           <div className="d-flex y-gap-10 flex-column">
    //             <p className="text-white">
    //               Spring Groove, Akruli Village, Akruli Road, Kandivali East,
    //               Mumbai, MH – 400101
    //             </p>
    //           </div>
    //         </div>

    //         <div className="col-xl-3 col-lg-4 col-sm-6">
    //           <h5 className="text-18 fw-500 mb-30">Important Links</h5>
    //           <div className="d-flex y-gap-10 flex-column">
    //             <a href="#">Home</a>
    //             <a href="#">Event Calendar</a>
    //             <a href="#">Our Foundation</a>
    //             <a href="#">List an Events</a>
    //             <a href="#">Privacy Policy</a>
    //           </div>
    //         </div>

    //         <div className="col-xl-3 col-lg-4 col-sm-6">
    //           <h5 className="text-18 fw-500 mb-30">Quick Links</h5>
    //           <div className="d-flex y-gap-10 flex-column">
    //             <a href="#">{"<5K"}</a>
    //             <a href="#">5K</a>
    //             <a href="#">10K</a>
    //             <a href="#">Half Marathon</a>
    //             <a href="#">Marathon</a>
    //           </div>
    //         </div>
    //       </div>
    //     </div>

    //     <div className="py-20 border-top-light">
    //       <div className="row justify-between items-center y-gap-10">
    //         <div className="col-auto">
    //           <div className="row x-gap-30 y-gap-10">
    //             <div className="col-auto">
    //               <div className="d-flex items-center">
    //                 © 2024 Fitizen India All rights reserved.
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </footer>

    <footer id="footer" class="footer -type-1 bg-grey text-white">
      <div class="container">
        <div class="py-60 lg:py-30">
          <div class="row y-gap-40 justify-between xl:justify-start">
            <div class="col-xl-3 col-lg-4 col-sm-6">
              <img src={footerLogo} alt="logo" style={{ width: "90%" }} />
              {/* <div className="d-flex gap-10">
                <img
                  src={phoneIcon}
                  alt="phone"
                  style={{ height: "24px", width: "24px" }}
                />
                <h5 class="text-16 fw-500 mb-10">Contact Us</h5>
              </div> */}
              {/* <div class="d-flex y-gap-5 flex-column">
                
                <div className="d-flex gap-10 mb-10">
                  
                  <h5 class="text-16 fw-500">Email</h5>
                </div>
                <a
                  href="mailto:fitizenindia@gmail.com"
                  className="text-15 fw-500 text-white mt-5"
                >
                  marketing@fitizenindia.com
                </a>
                <a
                  href="mailto:fitizenindia@gmail.com"
                  className="text-15 fw-500 text-white mt-5"
                >
                  supportevents@fitizenindia.com
                </a>
              </div> */}
            </div>

            <div class="col-xl-3 col-lg-4 col-sm-6">
              <div class="d-flex y-gap-5 flex-column">
                <div className="d-flex gap-10 mb-10">
                  <h5 class="text-16 fw-500">Email</h5>
                </div>
                <a
                  href="mailto:marketing@fitizenindia.com"
                  className="text-15 fw-500 text-white mt-5"
                >
                  marketing@fitizenindia.com
                </a>
                <a
                  href="mailto:supportevents@fitizenindia.com"
                  className="text-15 fw-500 text-white mt-5"
                >
                  supportevents@fitizenindia.com
                </a>
              </div>
              <div className="d-flex gap-10 mt-40">
                {/* <img
                  src={locationIcon}
                  alt="location"
                  style={{ height: "24px", width: "24px" }}
                /> */}
                <h5 class="text-16 fw-500 mb-10">Follow Us</h5>
              </div>
              {/* <div class="d-flex y-gap-10 flex-column">
                <p class="text-white text-13">
                  Spring Groove, Akruli Village, Akruli Road, Kandivali East,
                  Mumbai, MH – 400101
                </p>
              </div> */}
              <div className="d-flex x-gap-10 items-center mt-10">
                <a
                  target="_blank"
                  href="https://www.facebook.com/FitizenIndia?mibextid=LQQJ4d"
                  className="social-icon"
                  rel="noreferrer"
                >
                  <i className="fab fa-facebook-f text-20"></i>
                </a>
                <a
                  target="_blank"
                  href="https://youtube.com/@fitizenindia?si=qp3rKtDO-qtRNCzT"
                  className="social-icon"
                  rel="noreferrer"
                >
                  <i className="fab fa-youtube text-20"></i>
                </a>
                <a
                  target="_blank"
                  href="https://www.instagram.com/fitizenindia?igsh=dHVzamRwNzZzOXFz&utm_source=qr"
                  className="social-icon"
                  rel="noreferrer"
                >
                  <i className="fab fa-instagram text-20"></i>
                </a>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/fitizenindia/"
                  className="social-icon"
                  rel="noreferrer"
                >
                  <i className="fab fa-linkedin-in text-20"></i>
                </a>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <h5 className="text-16 fw-500 mb-10">Important Links</h5>
              <div className="d-flex y-gap-10 flex-column text-13">
                <ul className="custom-list">
                  <li>
                    <Link to="/term-condition">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/cancellation-policy">
                      Refund & Cancellation Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <h5 className="text-16 fw-500 mb-10">Quick Links</h5>
              <div className="d-flex y-gap-10 flex-column text-13">
                <ul className="custom-list">
                  <li>
                    <a href="/" className="cursor-pointer">
                      Home
                    </a>
                  </li>
                  <li>
                    <Link to="/event/list">Events</Link>
                  </li>
                  <li>
                    <a href="/blogs">Blogs</a>
                  </li>
                  <li>
                    <a href="/about-us">About Us</a>
                  </li>
                  <li>
                    <a href="/contact-us">Contact Us</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="py-20 border-top-light">
          <div className="row justify-between items-center y-gap-10">
            <div className="col-auto">
              <div className="row x-gap-30 y-gap-10">
                <div className="col-auto">
                  <div className="text-13">
                    Copyright © 2024 Fitizen India. All rights reserved.
                    Designed and Developed by{" "}
                    <span>
                      <a
                        className="underline"
                        href="https://www.we3.tech/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        We3 Tech Works.
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <div
                className="d-flex items-center justify-center w-45 h-45 bg-white rounded-full border-primary cursor-pointer"
                onClick={() => {
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }}
              >
                <img src={scrollTop} alt="scroll-top" className="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
